
import React from "react";
import { useSelector } from "react-redux";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment"
import logo from "./GTO-HEADER.png"
// Date Fns is used to format the dates we receive
// from our API call

// define a generatePDF function that accepts a tickets argument
function GeneratePDF(props) {

    const { user } = useSelector((state) => state.auth);
    const userDocument = user.uid ? user : user.payload;
    // initialize jsPDF
    const { columns, data, sign } = props

    async function generate() {
        const _columns = (Array.isArray(columns) ? columns : columns.map(col => col.text || ""))
        // const _widthed = [..._columns].map(col => ({ value: col, widthCh: 20 }))
        const _data = data.map(row => {
            const _row = []
            for (const _col of _columns) {
                _row.push(row[_col])
            }
            return _row
        })
        const doc = new jsPDF('l');
        const pageWidth = doc.internal.pageSize.width;  //Optional
        const pageHeight = doc.internal.pageSize.height;  //Optional
        const horizontalPos = pageWidth - 10;  //Can be fixed number
        const verticalPos = pageHeight - 6;  //Can be fixed number
        doc.addImage(logo, "png", 15, 0, 100, 25)
        if (props.name) {

            doc.text(props.name.toUpperCase(), horizontalPos - 10, 10, "right");
            if (sign) {
                doc.setFontSize(8)
                doc.text(props.sign.toUpperCase(), horizontalPos - 10, 15, "right");
                doc.setFontSize(12)


            }
        }
        doc.autoTable(_columns.map(col => String(col).toUpperCase()), _data, {
            startY: 25, headStyles: {
                fillColor: [60, 36, 92],
                valign: 'middle',
                halign: 'center'
            },
            styles: {
                fontSize: 6
            }
        });


        const date = Date().split(" ");
        // we use a date string to generate our filename.
        const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
        // ticket title. and margin-top + margin-left
        const pages = doc.internal.getNumberOfPages();

        doc.setFontSize(10);  //Optional

        for (let j = 1; j < pages + 1; j++) {

            doc.setPage(j);
            doc.text(`${j} of ${pages}`, horizontalPos, verticalPos, {
                align: 'right'
            });
            doc.text(`GENERATED by ${userDocument.name} ${userDocument.last_name} (${userDocument.email}) at ${moment().format("MMMM/DD/YY HH:mm:ss")}`, 10, verticalPos, {
                align: 'left'
            })
        }

        // we define the name of our PDF file.
        doc.save(`${props.name || "data"}_${dateStr}.pdf`);
    }

    return (
        <div>
            {React.cloneElement(props.children, { onClick: generate })}
        </div>
    );

};

export default GeneratePDF;